import { PageBlockItemV2 } from "@supernova-studio/model";
import { z } from "zod";

export const DTOPageBlockItemV2 = PageBlockItemV2;

export type DTOPageBlockItemV2 = z.infer<typeof DTOPageBlockItemV2>;
